/**
 * AvisoInline - Advertência compacta (triângulo + tooltip)
 *
 * Substitui os blocos de mensagem que ocupavam várias linhas do sheet.
 * O usuário vê apenas um triângulo de atenção ao lado do campo e, ao clicar,
 * lê a explicação completa. Camada de apresentação apenas.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-01 v1.0.0 - Criação (economia de espaço vertical no inspetor)
 */

import { AlertTriangle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export function AvisoInline({
  texto,
  rotulo,
  className,
}: {
  /** Texto completo da advertência, exibido no tooltip */
  texto: string;
  /** Rótulo curto opcional exibido ao lado do ícone */
  rotulo?: string;
  className?: string;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Ver advertência"
          className={cn(
            'inline-flex items-center gap-1 text-[11px] font-medium text-amber-600 transition-opacity hover:opacity-80 dark:text-amber-500',
            className,
          )}
        >
          <AlertTriangle className="h-3.5 w-3.5" />
          {rotulo && <span>{rotulo}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 text-xs leading-relaxed">
        {texto}
      </PopoverContent>
    </Popover>
  );
}
